const DEFAULT_BRAND = 'arbitrip';
const { LOGOS } = require('arbitrip-common/client/constants/BrandConstants');

const logoMap = {
    arbitrip: LOGOS.ARBITRIP,
    htzone: LOGOS.HTZ,
    letstay: LOGOS.LETSTAY,
};

const getBrandAssetFromHost = (() => {
    const cache = {};

    return function (map, defaultKey = DEFAULT_BRAND) {
        const cacheKey = JSON.stringify(map);
        if (cache[cacheKey]) {
            return cache[cacheKey];
        }

        const host = window.location.hostname;
        const parts = host.toLowerCase().split('.');

        for (const part of parts) {
            if (part in map) {
                cache[cacheKey] = map[part];
                return map[part];
            }
        }

        cache[cacheKey] = map[defaultKey];
        return map[defaultKey];
    };
})();

function getLogoForCurrentBrand() {
    return getBrandAssetFromHost(logoMap);
}

module.exports = {
    getLogoForCurrentBrand,
};
